import PropTypes from 'prop-types'
import React from 'react'

import routes from '../../router/routes'
import { chainDecorators, memoized } from '../../utils/ReactUtils'
import Link from '../Link'
import Image from '../../datas/models/Image'
import ImageGatsby from '../ImageGatsby'

import styles from './styles'


const decorators = [
  memoized,
]

function PictureCard(props) {
  const { title, subTitle, locale, slug, thumbnail } = props

  return (
    <div className="container">
      <Link
        route={routes.project.path}
        routeParams={{ locale, slug }}
      >
        <div className="mac">
          <div className="photo">
            <ImageGatsby src={thumbnail} />
          </div>
        </div>
        <div className="info">
          <p className="title">{title}</p>
          <p className="sub-title">{subTitle}</p>
        </div>
      </Link>
      <style jsx>{styles}</style>
    </div>
  )
}

PictureCard.propTypes = {
  thumbnail: PropTypes.oneOfType([PropTypes.string, Image.propTypes]).isRequired,
  title: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  slug: PropTypes.string,
  subTitle: PropTypes.string,
}

PictureCard.defaultProps = {
  subTitle: '',
  slug: '',
}

PictureCard = chainDecorators(decorators, PictureCard)

export default PictureCard
